// extracted by mini-css-extract-plugin
export default {"table":"table__R0NNO","red":"red__fDOE9"};